import { useContext } from 'react'
import RussianPokerStore from './RussianPokerStore'
import StoreContext from './providers/RussianPokerStoreProvider'

export const useRussianPokerStore = (): RussianPokerStore => {
  const context = useContext(StoreContext)

  if (!context) {
    throw new Error('useRussianPokerStore должен использоваться внутри RussianPokerStoreProvider')
  }
  return context
}
